'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function PortalPage() {
  const router = useRouter();

  useEffect(() => {
    router.push('/portal/login');
  }, [router]);

  return (
    <main className="page">
      <p className="eyebrow">Customer Portal</p>
      <h1>Redirecting…</h1>
      <p className="lead">
        Taking you to the sign-in page.
      </p>
    </main>
  );
}
